// src/utils/retry/wait-for-datastore-to-be-ready/wait-for-datastore-to-be-ready.ts
async function waitForDatastoreToBeReady(timeoutMs = 5e3) {
  const startTime = performance.now();
  while (performance.now() - startTime < timeoutMs) {
    if (typeof window !== "undefined" && window.yvaDatastore?.currentContextId) {
      return true;
    }
    await new Promise((resolve) => setTimeout(resolve, 250));
  }
  if (window?.yvaDatastore?.config.debug) {
    console.error("Timed out waiting for datastore to be ready.");
  }
  return false;
}

export {
  waitForDatastoreToBeReady
};
